import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoCustomerOverview} from "./models/DtoCustomerOverview";
import {SharedService} from "../../shared/shared.service";
import {DtoCustomerTreatmentSales} from "./models/DtoCustomerTreatmentSales";
import {DtoCustomerArticleSales} from "./models/DtoCustomerArticleSales";

@Injectable()
export class CustomerService {
    private apiUrl: string;

    constructor(private http: AzureApiService, private ss: SharedService) {
        this.apiUrl = 'customer'
    }

    public getCustomerById = (id: number): Observable<DtoCustomerOverview> => {
        return this.http.get<DtoCustomerOverview>(`${this.apiUrl}/overview/${id}`);
    };

    public getCustomerTreatmentSales = (id: number, checkDate: Date): Observable<DtoCustomerTreatmentSales[]> => {
        return this.http.get<DtoCustomerTreatmentSales[]>(`${this.apiUrl}/treatmentsales/${id}/${this.ss.formatDate(checkDate, 'yyyy-MM-dd')}`);
    };

    public getCustomerArticleSales = (id: number, checkDate: Date): Observable<DtoCustomerArticleSales[]> => {
        return this.http.get<DtoCustomerArticleSales[]>(`${this.apiUrl}/articlesales/${id}/${this.ss.formatDate(checkDate, 'yyyy-MM-dd')}`);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/customers/customer/customer.service.ts